import restAgent from '@/service/restAgent'
import { useGlobalStore } from '@/store/app'
import { StreamAttendeePlayer } from '@ghl-revex/assets-drm-client'
import { v4 as uuidv4 } from 'uuid'
import { reactive } from 'vue'

class MediaStateClass {
  state = reactive({
    activeLiveStreams: new Set<InstanceType<typeof StreamAttendeePlayer>>(),
  })
  async generateSignedUrlForImageUpload(fileType: string): Promise<any> {
    return restAgent.ClientPortal.getSignedUrlForProfileUpload(
      useGlobalStore().$state.locationId,
      uuidv4(),
      fileType
    )
  }

  async compressImage(imageCloudUrl: string, resolution = 256): Promise<any> {
    try {
      const locationId = useGlobalStore().$state.locationId

      return restAgent.ClientPortal.compressImage(
        imageCloudUrl,
        locationId,
        resolution
      )
    } catch (error) {
      console.error(error)
    }
  }
  addStream(streamRef) {
    this.state.activeLiveStreams.add(streamRef)
  }
  removeStream(streamRef: InstanceType<typeof StreamAttendeePlayer>) {
    this.state.activeLiveStreams.delete(streamRef)
  }
  leaveAllStreams() {
    this.state.activeLiveStreams.forEach(stream => {
      stream?.leaveStream()
    })
  }
  joinAllStreams() {
    this.state.activeLiveStreams?.forEach(stream => {
      try {
        stream?.joinStream?.('')
      } catch (error) {
        console.info('error joining stream', error)
      }
    })
  }
}

export const MediaState = new MediaStateClass()
